/* eslint-disable implicit-arrow-linebreak */
/* eslint-disable import/no-extraneous-dependencies */
import { useNamespace, useOkapiKy } from '@folio/stripes-core';
import { useQuery } from 'react-query';

function useCustomFieldsCategories(categoryId) {
  const okapiKy = useOkapiKy();
  const [namespace] = useNamespace({ key: 'customFieldsCategories' });

  const {
    isLoading,
    isError,
    data = {},
    refetch,
    ...rest
  } = useQuery(
    [namespace, categoryId],
    () =>
      okapiKy
        .get(
          categoryId
            ? `customField-category/${categoryId}`
            : 'customField-category?limit=2147483647',
        )
        .json(),
    { enabled: categoryId ? Boolean(categoryId) : true },
  );

  return {
    isLoading,
    isError,
    categories: categoryId ? data : data.customFieldsCategories,
    refetch,
    rest,
  };
}

export default useCustomFieldsCategories;
